import type { OperatorDefinition, OperationEvaluator } from '../types';
import { PRECEDENCE } from '../types';
import { box } from '../interpreter/boxing';
import { collectionsEqual } from './comparison';

export const evaluate: OperationEvaluator = async (input, context, left, right) => {
  // Use the unified comparison system
  const result = collectionsEqual(left, right);
  
  // null means incomparable (returns empty)
  if (result === null) {
    return { value: [], context };
  }
  
  // Return the boolean result
  return { value: [box(result, { type: 'Boolean', singleton: true })], context };
};

export const equalOperator: OperatorDefinition & { evaluate: OperationEvaluator } = {
  symbol: '=',
  name: 'equal',
  category: ['equality'],
  precedence: PRECEDENCE.EQUALITY,
  associativity: 'left',
  description: 'Returns true if the left collection is equal to the right collection. For single items, comparison is type-specific. For collections, comparison is order-dependent.',
  examples: ['name = "John"', 'Patient.name.given = "John"', '5 = 5', '@2018-03-01 = @2018-03-01'],
  signatures: [
    {
      name: 'equal',
      left: { type: 'Any', singleton: true },
      right: { type: 'Any', singleton: true },
      result: { type: 'Boolean', singleton: true },
    },
    {
      name: 'equal',
      left: { type: 'Any', singleton: false },
      right: { type: 'Any', singleton: false },
      result: { type: 'Boolean', singleton: true },
    }
  ],
  evaluate
};